module.exports = __webpack_public_path__ + "static/develop_banner-0e2603be2032ccae19e1b0ce3a0bd34f.png";